module.exports = __webpack_public_path__ + "src/assets/textures/molar/table_w_flask_lambert15_AO.jpg";